:host {
  --smart-features-list-item-checked-text-color: #{$color-typography-typo-88};
  --smart-features-list-item-unchecked-text-color: #{$color-typography-typo-64};
}
:host(.smart-features-list--light) {
  --smart-features-list-item-checked-text-color: #{$color-typography-typo-88};
  --smart-features-list-item-unchecked-text-color: #{$color-typography-typo-64};
}
:host(.smart-features-list--dark) {
  --smart-features-list-item-checked-text-color: #{$color-typography-typo-fff};
  --smart-features-list-item-unchecked-text-color: #{$color-typography-typo-fff};
}

.smart-features-list__ul {
  list-style: none;
  margin: 0;
  padding: 0;

  width: 100%;
}
